module.exports = __webpack_public_path__ + "img/user-group-simple-sharp-thin.bbd19774.svg";